/**
 * @fileoverview POST handler for the "/api/calculated_attributes/:app_group_id/unarchive" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postApiCalculatedAttributesAppGroupIdUnarchiveCacheKeys } from "./constants";
import type {
  PostApiCalculatedAttributesAppGroupIdUnarchiveProps,
  PostApiCalculatedAttributesAppGroupIdUnarchiveResult,
} from "./types";

// POST rather than the PATCH calculated filters uses -- see routes.rb.
export const postApiCalculatedAttributesAppGroupIdUnarchive = reactQueryMutationAdapter(
  postApiCalculatedAttributesAppGroupIdUnarchiveCacheKeys,
  (
    props: PostApiCalculatedAttributesAppGroupIdUnarchiveProps
  ): Promise<PostApiCalculatedAttributesAppGroupIdUnarchiveResult> => {
    const { app_group_id: appGroupId, calculated_attribute_ids: calculatedAttributeIds } = props;
    return fetch(
      `/api/calculated_attributes/${appGroupId}/unarchive`,
      "POST",
      { calculated_attribute_ids: calculatedAttributeIds },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
